
import { EstadosSiglaLabel } from "./../../../model/state";
import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ChangeDetectorRef, HostListener } from "@angular/core";
import {
  VehicleFilter,
  OpenService,
  MakeModel,
  Model,
  SelectableOption,
  PhotoOptions,
  InitVehicleFilter,
} from "src/app/shared/services/open.service";
import { FormControl } from "@angular/forms";
import { OemDealer, OemDealerType } from "src/app/shared/model/oem-dealer";
import { Observable, Subscription, combineLatest } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { City } from "src/app/shared/model/city";
import * as moment from "moment";
import { MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatRadioChange } from "@angular/material/radio";
import { MatSelectChange } from "@angular/material/select";
import {
  FuelEnum,
  TransmissionEnum,
  AuctionExpandedStatus,
  ReportStatus,
  SegmentLabel,
  AuctionStatus,
  DealTypeEnum,
  ReportType,
} from "src/app/shared/model/vehicle";
import { PageControl } from "@app-model/page-control";
import { IdName, OemDealerService, VehicleRemovalReason } from "@app-services/oem-dealer.service";
import { TargetBuyersLabel } from "@app/views/private/admin/model/advertisers";
import { SessionService } from "@app/store/session/session.service";
import { MarketPlacePersonalizationUtils } from "@app-components/layouts/shopkeeper-layout/marketplace-personalization";
import { LayoutVars, UserInfo } from "@app/store/session/session.store";
import { DecimalPipe } from "@angular/common";
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { NavigationService } from "@app-services/navigation.service";
import { FastQuoteService } from "@app-services/fast-quote.service";

@Component({
  selector: "app-filter-cast-off-vehicles",
  templateUrl: "./filter-cast-off-vehicles.component.html",
  styleUrls: ["./filter-cast-off-vehicles.component.scss"],
})
export class FilterCastOffVehiclesComponent implements OnInit {
  @Input() filter: VehicleFilter;
  @Input() showFinishedStatus: boolean;
  @Input() pageType: string;
  @Input() isMyVehicles: boolean;
  @Input() totalItems: number;
  @Input() hideOemDealerOptions: boolean;
  @Output() filterChanged: EventEmitter<VehicleFilter> = new EventEmitter();
  @Output() saveFilterChanged: EventEmitter<void> = new EventEmitter();
  @Input() displayFilters: boolean = false;
  @Input() page: "CAST_OFF" | "FAST_QUOTE" | "ALL" = "CAST_OFF";
  @Input() hideDealTypeFilter: boolean = false;
  @Output() selectedUfCitysOutput = new EventEmitter<City[]>();
  @Input() customHeight: string | null = null;

  fipeDiffStartStr: string;
  fipeDiffEndStr: string;
  private decimalPipe = new DecimalPipe('pt-BR');

  allSegments = SegmentLabel.allSegments;

  oemDealerControl: FormControl = new FormControl();
  oemDealerOptions: Observable<OemDealer[]>;

  cityControl: FormControl = new FormControl();
  cityOptions: Observable<City[]>;

  yearOptions: number[] = [];

  makeModels: MakeModel[] = [];
  locations: IdName[] = [];
  auctionLastPublishedByOptions: IdName[] = [];
  exclusiveGroups: IdName[] = [];

  makeAutoCompleteControl = new FormControl();
  makeOptions: Observable<MakeModel[]>;
  selectedMakes: MakeModel[] = [];

  cityUfCompleteControl = new FormControl();
  cityUfOptions: City[] = [];
  selectedUfCitys: City[] = [];

  models: Model[] = [];
  modelAutoCompleteControl = new FormControl();
  modelOptions: Observable<Model[]>;
  selectedModels: Model[] = [];

  fuelOptions: SelectableOption<FuelEnum>[];
  transmissionOptions: SelectableOption<TransmissionEnum>[];
  reportStatusOptions: SelectableOption<ReportStatus>[];
  dealTypeOptions: SelectableOption<DealTypeEnum>[];

  segmentOptions: IdName[] = [];
  filteredSegments: SegmentLabel[] = [];
  showSegmentFilter: boolean = false;
  showDealTypeFilter: boolean = false;
  
  reportOptions: IdName[];
  carManualQuantity: number;
  extraKeyOptions: number;
  dossierQuantity: number;

  statusOptions: SelectableOption<AuctionExpandedStatus>[];
  deletionReasonOptions: SelectableOption<VehicleRemovalReason>[];
  photoOptions: PhotoOptions[];
  selectedPhotoOption: PhotoOptions;

  addedEquipmentOptions: SelectableOption<IdName>[] = [];
  equipmentSearchResult: Observable<IdName[]>;
  allEquipments: IdName[];
  allOemDealerTypes = ['DEALERSHIP', 'CAR_RENTAL', 'BANK', 'RESELLER'];
  equipmentControl: FormControl = new FormControl();

  allTargets = TargetBuyersLabel.allTargets;


  states = EstadosSiglaLabel;

  routerSubs: Subscription;
  userInfo: UserInfo;

  initialFilter: InitVehicleFilter;

  selectedValueStart: number = 0;
  selectedValueEnd: number = 0;
  minFipe?: number;
  maxFipe?: number;
  fipeSliderDirty: boolean = false;

  oemDealerToppings = new FormControl();
  reportTypeControl = new FormControl();
  reportTypeOptions = Object.keys(ReportType).map(key => ({
    value: key,
    label: ReportType[key]
  }));
  selectedReportTypes: { value: string, label: string }[] = [];

  oemDealerToppingsList: IdName[] = [];

  displayedEquipmentCount = 10;

  loadingOemDealers: boolean = false;

  selectedModelsMake: { [makeId: string]: string[] } = {};

  childnavOpen: boolean;
  layoutVars: LayoutVars;

  constructor(
    private openService: OpenService,
    private oemDealerService: OemDealerService,
    private sessionService: SessionService,
    private elRef: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private navService: NavigationService,
    private fastQuoteService: FastQuoteService
  ) { }

  ngOnInit() {
    this.openService.getLayoutVars().subscribe(layoutVars => {
      this.layoutVars = layoutVars;
      MarketPlacePersonalizationUtils.initCssVars(this.elRef, layoutVars);
    });
    this.sessionService.getUser().subscribe(u => {
      this.userInfo = u;
    });
    this.initCityUfFilterOptions();
    this.initEquipments();
  }

  updateValue(applyToFilter: boolean = this.fipeSliderDirty) {
    if (this.selectedValueStart === undefined || this.selectedValueEnd === undefined) return;

    // Garante ordem e evita range inválido (start > end)
    let start = Number(this.selectedValueStart);
    let end = Number(this.selectedValueEnd);
    if (start > end) {
      [start, end] = [end, start];
    }

    // Clamp dentro do range disponível
    if (this.minFipe !== undefined) start = Math.max(this.minFipe, start);
    if (this.maxFipe !== undefined) end = Math.min(this.maxFipe, end);

    this.selectedValueStart = start;
    this.selectedValueEnd = end;

    if (applyToFilter) {
      this.filter.fipeDiffStart = start / 100;
      this.filter.fipeDiffEnd = end / 100;
    }
  }

  public loadMoreEquipment(): void {
    this.displayedEquipmentCount = this.allEquipments ? this.allEquipments.length : 10
  }

  public handleSelectedValues(selectedValues) {
    const selected = selectedValues.value
    const selectedIds = selected.map(item => item.id);
    this.filter.oemDealerIds = selectedIds;
    this.loadingOemDealers = false
  }

  onFipeSliderChange(): void {
    this.fipeSliderDirty = true;
    this.updateValue(true);
  }

  resetFipeSlider(): void {
    this.fipeSliderDirty = false;
    this.filter.fipeDiffStart = undefined;
    this.filter.fipeDiffEnd = undefined;
    if (this.minFipe !== undefined && this.maxFipe !== undefined) {
      this.selectedValueStart = this.minFipe;
      this.selectedValueEnd = this.maxFipe;
    }
    this.submitFilter();
  }

  public loadLessEquipment(): void {
    this.displayedEquipmentCount = 10;
  }

  onInput(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.initCityUfFilterOptions(inputValue);
  }


  resetFilter() {
    this.filter = new VehicleFilter();
    this.filter.pageControl = new PageControl();
    this.fipeSliderDirty = false;
  }

  clearCity(): void {
    this.filter.cityId = undefined;
    this.filter.cityRadius = undefined;
    localStorage.removeItem('defaultCityRadius');
    localStorage.removeItem('defaultCityId');
    localStorage.removeItem('defaultCityName');
    this.cityControl.setValue('');
    this.submitFilter();
  }

  public initFilterOptions(): void {
    this.hideOemDealerOptions = this.hideOemDealerOptions || this.layoutVars?.oemDealerId !== undefined;
    if (
      this.filter.cityId &&
      this.filter.cityId === localStorage.getItem("defaultCityId")
    ) {
      this.cityControl.setValue(localStorage.getItem("defaultCityName"));
    }
    this.oemDealerControl.valueChanges.subscribe((val) =>
      this.onChangeOemDealerQuery(val)
    );

    this.cityControl.valueChanges.subscribe((val) =>
      this.onChangeCityQuery(val)
    );
    this.initDealTypeOptions();
    this.initFuelOptions();
    this.initTransmissionOptions();
    this.initStatusOptions();
    this.initDeletionReasonOptions();
    this.initReportStatusOptions();

    if (this.filter.myVehicles) {
      this.initPhotoOptions();
    }
    if (this.filter.equipments) {
      this.initEquipments();
    }

    if (this.filter.oemDealerId && !this.oemDealerControl.value) {
      this.openService
        .getOemDealer(this.filter.oemDealerId)
        .subscribe((response) => this.oemDealerControl.setValue(response));
    }

    this.initDynamicFilterOptions();

    if (!this.filter.myVehicles && !this.filter.oemDealerTypes && !this.hideOemDealerOptions) {
      this.filter.oemDealerTypes = ['DEALERSHIP', 'CAR_RENTAL', 'BANK', 'RESELLER'];
    }

    if (typeof (this.filter.targets) === "string") {
      let target = this.filter.targets;
      this.filter.targets = [];
      this.filter.targets.push(target);
    }

    if ((this.filter.cityNames && this.filter.cityNames.length > 0) || (this.filter.ufsNames && this.filter.ufsNames.length > 0)) {

      if (this.filter.cityIds?.length) {
        this.selectedUfCitys = this.filter.cityIds.map((cityId, index) => {
          return { id: cityId, name: this.filter.cityNames[index], type: 'CITY', uf: this.filter.ufsNames[index] }
        });
        this.updateSelectedUfCitys(this.selectedUfCitys);
      }

      this.filter.cityNames = [];
      this.filter.ufsNames = [];
    }

    if (this.filter.ufs && this.filter.ufs.length > 0) {
      this.selectedUfCitys = this.filter.ufs.map((ufs) => {
        return { id: ufs, name: ufs, type: 'STATE', uf: ufs }
      });
      this.updateSelectedUfCitys(this.selectedUfCitys);
    }

    this.resetFipeDiffStrs();

    // Inicializar reportTypeControl com valores existentes
    if (this.filter.createdByReportTypes) {
      this.reportTypeControl.setValue(this.filter.createdByReportTypes);
    }
    this.updateSelectedReportTypes();
  }

  private initSelectedOemdealers(): void {

    if (this.filter.oemDealerIds && this.filter.oemDealerIds.length > 0) {
      const selectedIds = this.filter.oemDealerIds;

      this.oemDealerToppingsList.forEach(item => {
        item.selected = selectedIds.includes(item.id);
      });

      this.oemDealerToppings.setValue(this.oemDealerToppingsList.filter(option => option.selected));
    }
    this.loadingOemDealers = true;
  }

  private initSelecteMakeModels(options): void {

    if (this.filter.modelIds !== undefined && this.filter.modelIds.length > 0 && this.filter.makeIds?.length) {
      const correspondingMakes = options.makeModels.filter(make => this.filter.makeIds.includes(make.id));

      correspondingMakes.forEach(make => {
        const modelNames = make.models
          .filter(model => this.filter.modelIds.includes(model.id))
          .map(model => model.name);

        this.selectedModelsMake[make.id] = modelNames;
      });
    }

  }

  public initEquipments(): void {
    if (!this.allEquipments) {
      this.oemDealerService.getEquipmentOptions().subscribe((equips) => {
        this.allEquipments = equips;
        this.allEquipments.sort((i1, i2) => i1.name.localeCompare(i2.name));

        if (this.filter.equipments) {
          this.filter.equipments.forEach(e => this.addSelectedEquipment(e));
        }

        this.equipmentSearchResult = this.equipmentControl.valueChanges.pipe(
          startWith(''),
          map((value) => {
            if (value && typeof value === 'string') {
              value = value.toLowerCase();
            } else {
              value = '';
            }

            return this.allEquipments.filter(
              (option) =>
                option.name.toLowerCase().includes(value)
            );
          })
        );


      });
    }
  }

  public addSelectedEquipment(equipmentId: string): void {

    let option = this.addedEquipmentOptions.find(e => e.option.id === equipmentId);

    if (!option) {
      option = new SelectableOption<IdName>();
      option.option = this.allEquipments.find(e => {
        if (e.id === equipmentId) {
          e.selected = true;
          this.displayedEquipmentCount = this.allEquipments.length;
        }
      });
    }

    this.equipmentControl.setValue('');
  }

  public clearSelectedEquipment(): void {
    this.allEquipments.forEach(equipment => {
      equipment.selected = false;
    });
    this.filter.equipments = [];
  }

  public getEquipmentName(equipment?: IdName): string | undefined {
    return equipment ? equipment.name : undefined;
  }


  public updateEquipmentOption(option: IdName, event: MatCheckboxChange): void {

    if (!this.filter.equipments) {
      this.filter.equipments = [];
    }
    if (event.checked && this.filter.equipments.indexOf(option.id) < 0) {
      this.filter.equipments.push(option.id);
    }

    if (!event.checked) {
      this.filter.equipments = this.filter.equipments.filter(e => e !== option.id);
    }

  }

  private initDynamicFilterOptions(): void {

    if (this.page === 'CAST_OFF' || this.page === 'ALL') {
      this.openService
        .getFilterOptions(this.filter)
        .subscribe((options) => {

          if (!options || !options.minYear) {
            options.minYear = 2000;
          }
          const maxYear = moment().year() + 1;
          this.yearOptions.length = 0;
          for (let i = maxYear; i >= options.minYear; i--) {
            this.yearOptions.push(i);
          }
          if (options.minFipe !== undefined && options.maxFipe !== undefined) {
            this.minFipe = Math.round(parseFloat(options.minFipe.toString()) * 100);
            this.maxFipe = Math.round(parseFloat(options.maxFipe.toString()) * 100);

            // Inicializa o range do slider a partir do filtro atual (quando existir)
            const startFromFilter =
              this.filter?.fipeDiffStart !== undefined
                ? Math.round(this.filter.fipeDiffStart * 100)
                : this.minFipe;
            const endFromFilter =
              this.filter?.fipeDiffEnd !== undefined
                ? Math.round(this.filter.fipeDiffEnd * 100)
                : this.maxFipe;

            this.selectedValueStart = startFromFilter;
            this.selectedValueEnd = endFromFilter;
            const hasFipeOnFilter =
              this.filter?.fipeDiffStart !== undefined ||
              this.filter?.fipeDiffEnd !== undefined;
            this.fipeSliderDirty = this.fipeSliderDirty || hasFipeOnFilter;
            this.updateValue();
          }


          this.locations = options.locations;
          this.auctionLastPublishedByOptions = (options.auctionLastPublishedBy || [])
            .filter((user) => user?.id && user?.name?.trim())
            .map((user) => ({ ...user, name: user.name.trim() }))
            .sort((a, b) => a.name.localeCompare(b.name));
          this.makeModels = options.makeModels;
          this.exclusiveGroups = options.exclusiveGroups ? options.exclusiveGroups : [];
          this.carManualQuantity = options.carManualOptions;
          this.extraKeyOptions = options.extraKeyOptions;
          this.dossierQuantity = options.dossierOptions;
          this.reportOptions = options.reportOptions;

          const rawSegments: any = options.segmentOptions || {};
          this.segmentOptions = Array.isArray(rawSegments)
            ? rawSegments
            : Object.keys(rawSegments)
                .filter(k => rawSegments[k] > 0)
                .map(k => ({ id: k, name: k }));

          this.filteredSegments = this.allSegments.filter(segment =>
            (this.segmentOptions || []).some(option => (option?.id || option?.name) === segment.segment)
          );
          this.showSegmentFilter = this.filteredSegments.length > 1;

          this.makeOptions = this.makeAutoCompleteControl.valueChanges.pipe(
            startWith(""),
            map((value) => {
              if (value && typeof value === "string") {
                value = value.toLowerCase();
              } else {
                value = "";
              }
              return this.makeModels.filter((option) =>
                option.name.toLowerCase().includes(value)
              );
            })
          );

          if (
            this.filter.makeIds &&
            this.filter.makeIds.length > 0 &&
            this.selectedMakes.length === 0
          ) {
            this.selectedMakes = this.makeModels.filter(
              (m) => this.filter.makeIds.indexOf(m.id) >= 0
            );
          }

          this.models = [];
          this.makeModels.forEach((m) => {
            this.models.push({
              id: m.id,
              name: m.name,
              makeId: m.id,
              makeName: m.name,
              type: 'MAKE',
            });

            m.models.forEach((model) => this.models.push(model));
          });

          this.models.sort((m1, m2) => {
            if (m1.type < m2.type) return -1;
            if (m1.type > m2.type) return 1;

            return m1.name.localeCompare(m2.name);
          });


          this.modelOptions = this.modelAutoCompleteControl.valueChanges.pipe(
            startWith(""),
            map((value) => {
              if (value && typeof value === "string") {
                value = value.toLowerCase();
              } else {
                value = "";
              }
              return this.models.filter(
                (option) => option.name.toLowerCase().includes(value)
                // &&  this.isInSelectedMakes(option)
              );
            })
          );

          if (
            this.filter.modelIds &&
            this.filter.modelIds.length > 0 &&
            this.selectedModels.length === 0
          ) {
            this.selectedModels = this.models.filter(
              (m) => this.filter.modelIds.indexOf(m.id) >= 0
            );
          }

          const dealTypeQuantities: { [key in DealTypeEnum]: number } = {
            [DealTypeEnum.DEFAULT]: options.dealTypeOptions['DEFAULT'] || 0,
            [DealTypeEnum.FAST_QUOTE]: options.dealTypeOptions['FAST_QUOTE'] || 0,
            [DealTypeEnum.SHOWROOM]: options.dealTypeOptions['SHOWROOM'] || 0,
          };
          if (this.dealTypeOptions) {
            this.dealTypeOptions.forEach(d => d.quantity = dealTypeQuantities[d.option]);
          } else {
            this.dealTypeOptions = Object.keys(DealTypeEnum).map((key) => ({
              option: DealTypeEnum[key],
              quantity: dealTypeQuantities[DealTypeEnum[key]],
              selected: false,
            }));
          }
          const dealTypesWithQuantity = Object.values(dealTypeQuantities).filter(quantity => quantity > 0).length;
          this.showDealTypeFilter = (this.page === 'ALL') && dealTypesWithQuantity > 1;

          const fuelQuantities: { [key in FuelEnum]: number } = {
            [FuelEnum.ALCOHOL]: options.fuelOptions['ALCOHOL'] || 0,
            [FuelEnum.DIESEL]: options.fuelOptions['DIESEL'] || 0,
            [FuelEnum.FLEX]: options.fuelOptions['FLEX'] || 0,
            [FuelEnum.MULTIFLEX]: options.fuelOptions['MULTIFLEX'] || 0,
            [FuelEnum.GASOLINE]: options.fuelOptions['GASOLINE'] || 0,
            [FuelEnum.HYBRID]: options.fuelOptions['HYBRID'] || 0,
            [FuelEnum.GNV]: options.fuelOptions['GNV'] || 0,
            [FuelEnum.GASOLINE_GNV]: options.fuelOptions['GASOLINE_GNV'] || 0,
            [FuelEnum.ALCOHOL_GNV]: options.fuelOptions['ALCOHOL_GNV'] || 0,
            [FuelEnum.ELETRIC]: options.fuelOptions['ELETRIC'] || 0,
          };

          if (this.fuelOptions) {
            this.fuelOptions.forEach(f => f.quantity = fuelQuantities[f.option]);
          } else {
            this.fuelOptions = Object.keys(FuelEnum).map((key) => ({
              option: FuelEnum[key],
              quantity: fuelQuantities[FuelEnum[key]],
              selected: false,
            }));
          }

          const transmissionQuantities: { [key in TransmissionEnum]: number } = {
            [TransmissionEnum.AUTOMATIC]: options.transmissionOptions['AUTOMATIC'] || 0,
            [TransmissionEnum.MANUAL]: options.transmissionOptions['MANUAL'] || 0,
            [TransmissionEnum.SEMI_AUTOMATIC]: options.transmissionOptions['SEMI_AUTOMATIC'] || 0,
            [TransmissionEnum.AUTOMATED_MANUAL]: options.transmissionOptions['AUTOMATED_MANUAL'] || 0,
          };

          if (this.transmissionOptions) {
            this.transmissionOptions.forEach(t => t.quantity = transmissionQuantities[t.option])
          } else {
            this.transmissionOptions = Object.keys(TransmissionEnum).map((key) => ({
              option: TransmissionEnum[key],
              quantity: transmissionQuantities[TransmissionEnum[key]],
              selected: false,
            }));
          }

          if (options.oemDealers && options.oemDealers.length > 0) {
            this.oemDealerToppingsList = options.oemDealers.sort((a, b) => a.name.localeCompare(b.name));
          }

          this.initSelectedOemdealers();
          this.initSelecteMakeModels(options);
        });
    } else {
      this.fastQuoteService.getFilterOptions(this.filter)
        .subscribe((options) => {
          if (options.oemDealers && options.oemDealers.length > 0) {
            this.oemDealerToppingsList = options.oemDealers;

            const transmissionQuantities: { [key in TransmissionEnum]: number } = {
              [TransmissionEnum.AUTOMATIC]: options.transmissionOptions['AUTOMATIC'] || 0,
              [TransmissionEnum.MANUAL]: options.transmissionOptions['MANUAL'] || 0,
              [TransmissionEnum.SEMI_AUTOMATIC]: options.transmissionOptions['SEMI_AUTOMATIC'] || 0,
              [TransmissionEnum.AUTOMATED_MANUAL]: options.transmissionOptions['AUTOMATED_MANUAL'] || 0,
            };

            this.transmissionOptions = Object.keys(TransmissionEnum).map((key) => ({
              option: TransmissionEnum[key],
              quantity: transmissionQuantities[TransmissionEnum[key]],
              selected: false,
            }));

            this.carManualQuantity = options.carManualOptions;
            this.extraKeyOptions = options.extraKeyOptions;
            this.dossierQuantity = options.dossierOptions;
          }
        });
    }
  }

  private initCityUfFilterOptions(query?: string): void {
    const isFastQuote = this.page == 'FAST_QUOTE';
    this.openService
      .searchCitiesByName(query, this.filter, true, isFastQuote)
      .subscribe((response) => {
        this.cityUfOptions = response;
      });
  }

  private initDeletionReasonOptions() {
    this.deletionReasonOptions = [];

    if (this.filter.statuses.indexOf('DELETED') >= 0) {
      for (const reason of Object.keys(VehicleRemovalReason)) {
        this.addEnumOption(
          this.deletionReasonOptions,
          this.filter.reasonsDeletion,
          VehicleRemovalReason[reason],
          VehicleRemovalReason
        );
      }
    }
  }

  private initStatusOptions(): void {
    this.statusOptions = [];

    if (this.filter.myVehicles && this.filter.statuses.indexOf('DELETED') < 0) {
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.NO_AUCTION,
        AuctionExpandedStatus
      );
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.INACTIVE,
        AuctionExpandedStatus
      );
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.WAITING_PUBLICATION,
        AuctionExpandedStatus
      );
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.WAITING_FIRST_BID,
        AuctionExpandedStatus
      );
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.FAST_QUOTE,
        AuctionExpandedStatus
      );
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.FAST_QUOTE_WITH_OFFER,
        AuctionExpandedStatus
      );
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.WITH_BIDS,
        AuctionExpandedStatus
      );
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.PENDING_ALTERNATIVE_BID,
        AuctionExpandedStatus
      );
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.PENDING_CONDITIONAL_OFFER,
        AuctionExpandedStatus
      );
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.INTEGRATED_SUPERBID,
        AuctionExpandedStatus
      );
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.REPUBLISHED_MULTIPLE_TIMES,
        AuctionExpandedStatus
      );
    }
    if ((this.filter.myVehicles && this.filter.statuses.indexOf('DELETED') < 0) || this.showFinishedStatus) {
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.SOLD_NO_PAYMENT,
        AuctionExpandedStatus
      );
      this.addEnumOption(
        this.statusOptions,
        this.filter.expandedStatuses,
        AuctionExpandedStatus.SOLD_WITH_PAYMENT,
        AuctionExpandedStatus
      );
    }
  }

  private initPhotoOptions(): void {
    if (!this.photoOptions) {
      this.photoOptions = [
        PhotoOptions.ALL,
        PhotoOptions.WITH_PHOTOS,
        PhotoOptions.WITHOUT_PHOTOS,
      ];
    }

    if (this.filter.withPhotos === undefined) {
      this.selectedPhotoOption = PhotoOptions.ALL;
    } else if (this.filter.withPhotos) {
      this.selectedPhotoOption = PhotoOptions.WITH_PHOTOS;
    } else {
      this.selectedPhotoOption = PhotoOptions.WITHOUT_PHOTOS;
    }
  }

  public initTransmissionOptions(): void {
    this.transmissionOptions = [];
    this.addEnumOption(
      this.transmissionOptions,
      this.filter.transmissions,
      TransmissionEnum.MANUAL,
      TransmissionEnum
    );
    this.addEnumOption(
      this.transmissionOptions,
      this.filter.transmissions,
      TransmissionEnum.AUTOMATIC,
      TransmissionEnum
    );
    this.addEnumOption(
      this.transmissionOptions,
      this.filter.transmissions,
      TransmissionEnum.AUTOMATED_MANUAL,
      TransmissionEnum
    );
    this.addEnumOption(
      this.transmissionOptions,
      this.filter.transmissions,
      TransmissionEnum.SEMI_AUTOMATIC,
      TransmissionEnum
    );
  }

  public initReportStatusOptions(): void {
    this.reportStatusOptions = [];

    this.addEnumOption(
      this.reportStatusOptions,
      this.filter.reportStatuses,
      ReportStatus.APPROVED,
      ReportStatus
    );
    this.addEnumOption(
      this.reportStatusOptions,
      this.filter.reportStatuses,
      ReportStatus.WITH_RESTRICTIONS,
      ReportStatus
    );
    this.addEnumOption(
      this.reportStatusOptions,
      this.filter.reportStatuses,
      ReportStatus.DISAPPROVED,
      ReportStatus
    );
  }

  private addEnumOption(
    selectableOptions: SelectableOption<any>[],
    selectedOptions: string[],
    option: any,
    enumType: any,

  ): void {

    const selectableOption = new SelectableOption<any>();

    selectableOption.option = option;

    selectableOption.selected =
      selectedOptions &&
      selectedOptions.indexOf(this.getEnumKey(option, enumType)) >= 0;
    selectableOptions.push(selectableOption);
  }

  public initDealTypeOptions(): void {
    this.dealTypeOptions = [];

    this.addEnumOption(
      this.dealTypeOptions,
      this.filter.dealTypes,
      DealTypeEnum.DEFAULT,
      DealTypeEnum
    );
    this.addEnumOption(
      this.dealTypeOptions,
      this.filter.dealTypes,
      DealTypeEnum.FAST_QUOTE,
      DealTypeEnum
    );
    this.addEnumOption(
      this.dealTypeOptions,
      this.filter.dealTypes,
      DealTypeEnum.SHOWROOM,
      DealTypeEnum
    );
  }

  public initFuelOptions() {
    this.fuelOptions = [];

    this.addEnumOption(
      this.fuelOptions,
      this.filter.fuels,
      FuelEnum.ALCOHOL,
      FuelEnum
    );
    this.addEnumOption(
      this.fuelOptions,
      this.filter.fuels,
      FuelEnum.DIESEL,
      FuelEnum
    );
    this.addEnumOption(
      this.fuelOptions,
      this.filter.fuels,
      FuelEnum.FLEX,
      FuelEnum
    );
    this.addEnumOption(
      this.fuelOptions,
      this.filter.fuels,
      FuelEnum.GASOLINE,
      FuelEnum
    );
    this.addEnumOption(
      this.fuelOptions,
      this.filter.fuels,
      FuelEnum.HYBRID,
      FuelEnum
    );
    this.addEnumOption(
      this.fuelOptions,
      this.filter.fuels,
      FuelEnum.MULTIFLEX,
      FuelEnum
    );
    this.addEnumOption(
      this.fuelOptions,
      this.filter.fuels,
      FuelEnum.ELETRIC,
      FuelEnum
    );
    this.addEnumOption(
      this.fuelOptions,
      this.filter.fuels,
      FuelEnum.GNV,
      FuelEnum
    );
  }

  private isInSelectedMakes(model: Model): boolean {
    if (this.selectedMakes === undefined || this.selectedMakes.length === 0) {
      return true;
    }
    for (const make of this.selectedMakes) {
      if (make.models.indexOf(model) >= 0) {
        return true;
      }
    }
    return false;
  }

  getMakeName(makeModel?: MakeModel): string | undefined {
    return makeModel ? makeModel.name : undefined;
  }

  getCityUf(cityUfModel?: any): string | undefined {
    return cityUfModel ? cityUfModel.name : undefined;
  }

  selectedMake(event: MatAutocompleteSelectedEvent): void {
    const selectedMake = event.option.value;
    if (this.filter.makeIds === undefined) {
      this.filter.makeIds = [];
    }
    if (this.selectedMakes.indexOf(selectedMake) < 0) {
      this.selectedMakes.push(selectedMake);
      this.filter.makeIds.push(selectedMake.id);
      this.submitFilter();
    }
    this.makeAutoCompleteControl.setValue("");
  }

  selectedMakeInitial(make): void {
    const selectedMake = make;
    if (this.filter.makeIds === undefined) {
      this.filter.makeIds = [];
    }
    if (this.selectedMakes.indexOf(selectedMake) < 0) {
      this.selectedMakes.push(selectedMake);
      this.filter.makeIds.push(selectedMake.id);
    }
    this.makeAutoCompleteControl.setValue("");
  }


  selectedCityUf(event: MatAutocompleteSelectedEvent): void {
    const selectedCityUfOption = event.option.value;
    if (this.filter.cityIds === undefined) {
      this.filter.cityIds = [];
      this.filter.cityNames = []
    }
    if (this.filter.ufs === undefined) {
      this.filter.ufs = [];
      this.filter.ufsNames = [];
    }
    const isCityIdExists = this.filter.cityIds.includes(selectedCityUfOption.id);
    const isUfExists = this.filter.ufs.includes(selectedCityUfOption.uf);

    if (selectedCityUfOption.type === "CITY") {
      if (!isCityIdExists) {
        this.filter.cityIds.push(selectedCityUfOption.id);
        this.filter.cityNames.push(selectedCityUfOption.name);
        this.filter.ufsNames.push(selectedCityUfOption.uf);
        this.selectedUfCitys.push(selectedCityUfOption);
      }
    } else {
      if (!isUfExists) {
        this.filter.ufs.push(selectedCityUfOption.uf);
        this.selectedUfCitys.push(selectedCityUfOption);
      }
    }
    this.updateSelectedUfCitys(this.selectedUfCitys);
    this.cityUfCompleteControl.setValue("");
  }

  updateSelectedUfCitys(ufCitys: City[]) {
    this.selectedUfCitysOutput.emit(ufCitys);
  }

  removeSelectetCityUf(option: City): void {
    const index = this.selectedUfCitys.findIndex(item => item.id === option.id);
    if (index !== -1) {
      this.selectedUfCitys.splice(index, 1);

      if (option.type === "CITY") {
        const cityIdIndex = this.filter.cityIds.indexOf(option.id);
        if (cityIdIndex !== -1) {
          this.filter.cityIds.splice(cityIdIndex, 1);
        }
      } else {
        const ufIndex = this.filter.ufs.indexOf(option.uf);
        if (ufIndex !== -1) {
          this.filter.ufs.splice(ufIndex, 1);
        }
      }
    }
  }

  selectReportType(event: MatSelectChange): void {
    this.filter.createdByReportTypes = event.value;
    this.updateSelectedReportTypes();
  }

  removeReportType(reportType: string): void {
    if (!this.filter.createdByReportTypes) {
      return;
    }
    this.filter.createdByReportTypes = this.filter.createdByReportTypes.filter(type => type !== reportType);
    this.reportTypeControl.setValue(this.filter.createdByReportTypes);
    this.updateSelectedReportTypes();
  }

  private updateSelectedReportTypes(): void {
    this.selectedReportTypes = this.filter.createdByReportTypes 
      ? this.filter.createdByReportTypes.map(value => {
          const option = this.reportTypeOptions.find(opt => opt.value === value);
          return option || { value, label: value };
        })
      : [];
  }

  removeSelectedMake(make: MakeModel): void {
    const makeModels = this.selectedModelsMake[make.id];

    if (makeModels) {
      makeModels.map((makeModel) => {
        const idModel = make.models.find((model) => model.name === makeModel)
        this.filter.modelIds = this.filter.modelIds.filter((id) => id !== idModel.id);
      });
    }

    if (this.selectedModelsMake.hasOwnProperty(make.id)) {
      delete this.selectedModelsMake[make.id];
    }
    this.selectedMakes = this.selectedMakes.filter((m) => m.id !== make.id);
    this.filter.makeIds = this.filter.makeIds.filter((id) => id !== make.id);
  }

  getModelName(model?: Model): string | undefined {
    return model ? model.name : undefined;
  }

  selectedModel(event: MatAutocompleteSelectedEvent): void {
    const selectedModel = event.option.value;
    if (selectedModel.type === "MAKE") {
      const correspondingMake = this.makeModels.find((make) => make.id === selectedModel.id);
      this.selectedMakeInitial(correspondingMake);
    } else {
      const selectedMake = this.makeModels.find((make) => make.id === selectedModel.makeId);
      const selectedOption = selectedMake.models.find((make) => make.id === selectedModel.id);
      this.selectedMakeInitial(selectedMake);
      if (selectedOption.type === "MODEL") {
        if (this.filter.modelIds === undefined) {
          this.filter.modelIds = [];
        }
        if (this.selectedModelsMake[selectedMake.id] !== undefined) {
          const isModelSelected = this.selectedModelsMake[selectedMake.id].includes(selectedOption.name);

          if (!isModelSelected) {
            if (!this.selectedModelsMake[selectedMake.id]) {
              this.selectedModelsMake[selectedMake.id] = [];
            }
            this.selectedModelsMake[selectedMake.id].push(selectedOption.name);
            this.filter.modelIds.push(selectedOption.id);
          }
        } else {
          if (!this.selectedModelsMake[selectedMake.id]) {
            this.selectedModelsMake[selectedMake.id] = [];
          }
          this.filter.modelIds.push(selectedOption.id);
          this.selectedModelsMake[selectedMake.id].push(selectedOption.name);
        }
      }

    }


    // if (this.selectedModels.indexOf(selectedModel) < 0) {
    //   this.selectedModels.push(selectedModel);
    //   this.filter.modelIds.push(selectedModel.id);
    //   this.submitFilter();
    // }
    this.modelAutoCompleteControl.setValue("");
  }

  selectedModelMake(event): void {
    const selectedMake = event.value.make;
    const selectedOption = event.value.option;
    if (selectedOption.type === "MODEL") {
      if (this.filter.modelIds === undefined) {
        this.filter.modelIds = [];
      }
      if (this.selectedModelsMake[selectedMake.id] !== undefined) {
        const isModelSelected = this.selectedModelsMake[selectedMake.id].includes(selectedOption.name);

        if (!isModelSelected) {
          if (!this.selectedModelsMake[selectedMake.id]) {
            this.selectedModelsMake[selectedMake.id] = [];
          }
          this.filter.modelIds.push(selectedOption.id);
          this.selectedModelsMake[selectedMake.id].push(selectedOption.name);
        }
      } else {
        if (!this.selectedModelsMake[selectedMake.id]) {
          this.selectedModelsMake[selectedMake.id] = [];
        }
        this.filter.modelIds.push(selectedOption.id);
        this.selectedModelsMake[selectedMake.id].push(selectedOption.name);
      }
    }
  }

  removeSelectedModelMake(makeId: string, modelName: string, make): void {
    const index = this.selectedModelsMake[makeId].indexOf(modelName);

    if (index !== -1) {
      this.selectedModelsMake[makeId].splice(index, 1);
    }

    const idModel = make.models.find((model) => model.name === modelName)

    this.filter.modelIds = this.filter.modelIds.filter((id) => id !== idModel.id);
  }


  removeSelectedModel(model: Model): void {
    this.selectedModels = this.selectedModels.filter((m) => m.id !== model.id);
    this.filter.modelIds = this.filter.modelIds.filter((id) => id !== model.id);
  }

  getModelMakeName(makeId: string, modelName: string): string {
    return modelName;
  }


  submitFilter(): void {
    if (!this.filter.cityRadius) {
      localStorage.removeItem('defaultCityRadius');
    }
    this.filterChanged.emit(this.filter);
    this.initDynamicFilterOptions();
  }

  changeSegment(newSegment: string): void {
    if (!this.filter.segments) {
      this.filter.segments = [];
    }

    if (this.filter.segments.indexOf(newSegment) >= 0) {
      this.filter.segments = this.filter.segments.filter(s => s !== newSegment);
    } else {
      this.filter.segments.push(newSegment);
    } 
  }

  onChangeOemDealerQuery(value: string | OemDealer) {
    if (typeof value !== "string") {
      this.filter.oemDealerId = value.id;
      this.oemDealerControl.setValue(value.name);
    } else {
      this.oemDealerOptions = this.openService.searchOemDealersByName(value, true, this.page == 'FAST_QUOTE');
    }
  }

  checkResetOemDealer(): void {
    if (
      this.oemDealerControl.value === "" &&
      this.filter.oemDealerId !== undefined
    ) {
      this.filter.oemDealerId = undefined;
      this.submitFilter();
    }
  }

  selectOemDealer(oemDealer: OemDealer) {
    this.filter.oemDealerId = oemDealer.id;
    this.submitFilter();
  }

  onChangeCityQuery(value: string | City) {
    if (typeof value !== "string") {
      this.filter.cityId = value.id;
      this.cityControl.setValue(value.name + " - " + value.uf);
    } else {
      this.cityOptions = this.openService.searchCitiesByName(
        value,
        this.filter
      );
    }
  }

  checkResetCity(): void {
    if (this.cityControl.value === "" && this.filter.cityId !== undefined) {
      this.filter.cityId = undefined;
      this.submitFilter();
    }
  }

  selectCity(city: City) {
    this.filter.cityId = city.id;
    this.submitFilter();
    localStorage.setItem("defaultCityName", city.name + " - " + city.uf);
    localStorage.setItem("defaultCityId", city.id);
  }

  get sortOptions(): string {
    return (
      this.filter.pageControl.sortField +
      "_" +
      this.filter.pageControl.sortDirection
    );
  }

  set sortOptions(options: string) {
    const optionsArr = options.split("_");
    this.filter.pageControl.sortField = optionsArr[0];
    this.filter.pageControl.sortDirection =
      optionsArr[1] === "DESC" ? "DESC" : "ASC";

    this.submitFilter();
  }

  get minYearOptions(): number[] {
    return this.yearOptions.filter(
      (y) =>
        this.filter.modelYearEnd === undefined || y <= this.filter.modelYearEnd
    );
  }

  get maxYearOptions(): number[] {
    return this.yearOptions.filter(
      (y) =>
        this.filter.modelYearStart === undefined ||
        y >= this.filter.modelYearStart
    );
  }

  updateDealType(option: DealTypeEnum, event: MatCheckboxChange): void {
    if (!this.filter.dealTypes) {
      this.filter.dealTypes = [];
    }
    const key = this.getEnumKey(option, DealTypeEnum);
    if (event.checked && this.filter.dealTypes.indexOf(key) < 0) {
      this.filter.dealTypes.push(key);
    }

    if (!event.checked) {
      this.filter.dealTypes = this.filter.dealTypes.filter((f) => f !== key);
    }

    if (this.filter.dealTypes.length === 0) {
      this.filter.dealTypes = undefined;
    }
  }

  updateFuel(option: FuelEnum, event: MatCheckboxChange): void {
    if (!this.filter.fuels) {
      this.filter.fuels = [];
    }
    const key = this.getEnumKey(option, FuelEnum);
    if (event.checked && this.filter.fuels.indexOf(key) < 0) {
      this.filter.fuels.push(key);
    }

    if (!event.checked) {
      this.filter.fuels = this.filter.fuels.filter((f) => f !== key);
    }
  }

  updateTransmission(option: TransmissionEnum, event: MatCheckboxChange): void {
    if (!this.filter.transmissions) {
      this.filter.transmissions = [];
    }
    const key = this.getEnumKey(option, TransmissionEnum);
    if (event.checked && this.filter.transmissions.indexOf(key) < 0) {
      this.filter.transmissions.push(key);
    }

    if (!event.checked) {
      this.filter.transmissions = this.filter.transmissions.filter(
        (f) => f !== key
      );
    }
  }

  updateReportStatus(option: ReportStatus, event: MatCheckboxChange): void {
    if (!this.filter.reportStatuses) {
      this.filter.reportStatuses = [];
    }
    const key = this.getEnumKey(option, ReportStatus);
    if (event.checked && this.filter.reportStatuses.indexOf(key) < 0) {
      this.filter.reportStatuses.push(key);
    }

    if (!event.checked) {
      this.filter.reportStatuses = this.filter.reportStatuses.filter(
        (f) => f !== key
      );
    }
  }

  getReportQuantity(option: ReportStatus): number {
    const key = this.getEnumKey(option, ReportStatus);

    return this.reportOptions ? this.reportOptions[key] : 0;
  }

  updateStatus(option: AuctionExpandedStatus, event: MatCheckboxChange): void {
    if (!this.filter.expandedStatuses) {
      this.filter.expandedStatuses = [];
    }
    const key = this.getEnumKey(option, AuctionExpandedStatus);
    if (event.checked && this.filter.expandedStatuses.indexOf(key) < 0) {
      this.filter.expandedStatuses.push(key);
    }

    if (!event.checked) {
      this.filter.expandedStatuses = this.filter.expandedStatuses.filter(
        (f) => f !== key
      );
    }
  }

  updateDeletionReason(option: VehicleRemovalReason, event: MatCheckboxChange): void {
    if (!this.filter.reasonsDeletion) {
      this.filter.reasonsDeletion = [];
    }
    const key = this.getEnumKey(option, VehicleRemovalReason);
    if (event.checked && this.filter.reasonsDeletion.indexOf(key) < 0) {
      this.filter.reasonsDeletion.push(key);
    }

    if (!event.checked) {
      this.filter.reasonsDeletion = this.filter.reasonsDeletion.filter(
        (f) => f !== key
      );
    }
  }

  updatePhotoOptions(option: PhotoOptions, event: MatRadioChange): void {
    switch (option) {
      case PhotoOptions.ALL:
        this.filter.withPhotos = undefined;
        break;
      case PhotoOptions.WITH_PHOTOS:
        this.filter.withPhotos = true;
        break;
      case PhotoOptions.WITHOUT_PHOTOS:
        this.filter.withPhotos = false;
        break;
    }
  }

  private getEnumKey(enumValue: any, enumType: any): string {
    const idx = Object.values(enumType).indexOf(enumValue);
    return Object.keys(enumType)[idx];
  }

  getOemDealerTypeLabel(type: string): string {
    return OemDealerType[type];
  }

  toggleOemDealerType(type: string): void {
    if (!this.filter.oemDealerTypes) {
      this.filter.oemDealerTypes = [];
    }

    if (this.filter.oemDealerTypes.indexOf(type) >= 0) {
      this.filter.oemDealerTypes = this.filter.oemDealerTypes.filter(s => s !== type);
    } else {
      this.filter.oemDealerTypes.push(type);
    }
  }

  getTargetLabel(label: string): string {
    if (label == 'EXCLUSIVE_GROUPS') {
      return "Grupos exclusivos"
    }
    return TargetBuyersLabel.getLabel(label);
  }

  updateTarget(target: string, event: MatCheckboxChange): void {
    if (!this.filter.targets) {
      this.filter.targets = [];
    }

    if (event.checked) {
      this.filter.targets.push(target);
    } else {
      this.filter.targets = this.filter.targets.filter(t => t !== target);
    }

  }

  updateExclusiveGroup(group: string, event: MatCheckboxChange): void {
    if (!this.filter.dealersExclusiveGroups) {
      this.filter.dealersExclusiveGroups = [];
    }

    if (event.checked) {
      this.filter.dealersExclusiveGroups.push(group);
    } else {
      this.filter.dealersExclusiveGroups = this.filter.dealersExclusiveGroups.filter(g => g !== group);
    }

  }

  handleFipeDiffInput(value: string, end: boolean) {
    let numericValue = parseFloat(value);

    if (end) {
      this.filter.fipeDiffEnd = numericValue / 100;
    } else {
      this.filter.fipeDiffStart = numericValue / 100;
    }
    this.resetFipeDiffStrs();

  }

  resetFipeDiffStrs(): void {
    if (this.filter.fipeDiffStart !== undefined) {
      this.fipeDiffStartStr = this.decimalPipe.transform(100 * this.filter.fipeDiffStart, '1.0-0') + '%';
    } else {
      this.fipeDiffStartStr = undefined;
    }
    if (this.filter.fipeDiffEnd !== undefined) {
      this.fipeDiffEndStr = this.decimalPipe.transform(100 * this.filter.fipeDiffEnd, '1.0-0') + '%';
    } else {
      this.fipeDiffEndStr = undefined;
    }
  }

  handleKeydown(direction: string, end: boolean) {
    let value;
    if (direction == "UP") {
      value = 0.01;
    } else {
      value = -0.01;
    }

    if (end) {
      if (this.filter.fipeDiffEnd === undefined) {
        this.filter.fipeDiffEnd = 0;
      }
      this.filter.fipeDiffEnd += value
    } else {

      if (this.filter.fipeDiffStart === undefined) {
        this.filter.fipeDiffStart = 0;
      }
      this.filter.fipeDiffStart += value;
    }

    this.resetFipeDiffStrs();
  }

  handleFirstPublication(event: MatSelectChange): void {
    let numberOfDays = event.value;
    let firstPublishedAt = moment(new Date()).subtract(numberOfDays, 'days').format();

    this.filter.firstPublishedAtIni = firstPublishedAt;
  }

  getFirstPublication(): number {
    if (!this.filter.firstPublishedAtIni) {
      return undefined;
    }

    let oldDate = moment(this.filter.firstPublishedAtIni);
    let currentDate = moment(new Date());

    let differenceInDays = currentDate.diff(oldDate, 'days');

    return differenceInDays;
  }

  isDealer(): boolean {
    return this.userInfo && this.userInfo.dealerId && this.userInfo.hasRole('DEALER');
  }

  canCreateFilter(): boolean {
    return this.isDealer();
  }

  public emitterEventSaveFilter(): void {
    this.saveFilterChanged.emit()
  }

  public handleSubmitFilter(): void {
    this.submitFilter();
  }

  public handleClearFilter(): void {
    const pathWithoutQuery = this.location.path().split('?')[0];
    this.location.replaceState(pathWithoutQuery);

    this.initFilterOptions();
    this.initDynamicFilterOptions();
  }

  routeToStart() {
    const pathWithoutQuery = this.location.path().split('?')[0];
    if (String(this.route.url).indexOf(pathWithoutQuery)) {
      this.router
        .navigate(['/vender/veiculos'], {
          queryParams: { refresh: new Date().getTime() },
        })
        .then((a) => {
          this.router.navigate([pathWithoutQuery], {
            queryParams: { refresh: new Date().getTime() },
          });
        });
    } else {
      this.router.navigate(['/']);
    }
  }

  toggleSidebar() {
    const state = this.navService.sidebarState;
    if (state.childnavOpen) {
      this.childnavOpen = false;
      return (state.childnavOpen = false);
    } else {
      this.childnavOpen = true;
      return (state.childnavOpen = true);
    }
  }
}